import NoteListWrapper from "../../../components/Notes/List/NoteListWrapper/NoteListWrapper";

export default function Notes() {
    return <NoteListWrapper />;
}
